import { Observable, throwError } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { SiToastNotificationService } from '@siemens/element-ng/toast-notification';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private toastService = inject(SiToastNotificationService);

    public handleError<T>(operation?: string): (error: Error) => Observable<T> {
        return (error: Error): Observable<T> => {
            this.toastService.showToastNotification({
                title: `Error: ${operation}`,
                message: `${error?.name}`,
                state: 'danger',
                timeout: 50000
            });
            return throwError(() => error);
        };
    }
}
